import type { ReactNode } from 'react'
import { ThemeProvider } from 'baseui'
import { PulseScopeContext } from './pulseScopeContext'
import usePulseScopeTheme from './usePulseScopeTheme'

interface PulseScopeProps {
  enabled: boolean
  children: ReactNode
}

const PulseScope = ({ enabled, children }: PulseScopeProps) => {
  const pulseTheme = usePulseScopeTheme()

  if (!enabled) return <>{children}</>

  return (
    <PulseScopeContext.Provider value={true}>
      <ThemeProvider theme={pulseTheme}>{children}</ThemeProvider>
    </PulseScopeContext.Provider>
  )
}

export default PulseScope
